import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';

import { ACCENT_SX, BulkRunProps } from './dialogShared';
import { BulkRunStatus } from '../../../components/molecules/BulkRunStatus';

export const NoteDialog: React.FC<
  {
    open: boolean;
    isBulk: boolean;
    count: number;
    submitting: boolean;
    lastError: string | null;
    onClose: () => void;
    onSubmit: (note: string) => Promise<void>;
  } & BulkRunProps
> = ({ open, isBulk, count, submitting, lastError, onClose, onSubmit, progress, failures }) => {
  const [note, setNote] = useState('');
  useEffect(() => {
    if (open) setNote('');
  }, [open]);
  const title = isBulk ? `Add Note (${count} jobs)` : 'Add Note';

  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      aria-label={title}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          label="Note"
          multiline
          minRows={3}
          maxRows={6}
          fullWidth
          value={note}
          onChange={(e) => setNote(e.target.value)}
          sx={{ mt: 1 }}
          aria-label="Note content"
        />
        <BulkRunStatus
          progress={progress}
          submitting={submitting}
          failures={failures}
          error={lastError}
          verb="Noting"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting} aria-label="Cancel add note">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onSubmit(note)}
          disabled={!note.trim() || submitting}
          sx={ACCENT_SX}
          aria-label="Submit note"
        >
          {submitting ? <CircularProgress size={18} color="inherit" /> : 'Add Note'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
